import React from "react";
import { Modal, Segment, Button, Image } from "semantic-ui-react";
import { connect } from "react-redux";

import { resetConnection } from "../../../../store/actions/connection";
import { withRouter } from "react-router-dom";
import menuBtnClose from "../../../../semantic/dist/themes/fibrestream/assets/images/menu-close.svg";
import { Config } from '../../../../data/config';
import axios from "axios";
import redImage from "../../../../semantic/dist/themes/fibrestream/assets/images/oval_prime.png";
import lightImage from "../../../../semantic/dist/themes/fibrestream/assets/images/oval_light.png";
import blackImage from "../../../../semantic/dist/themes/fibrestream/assets/images/oval_black.png";
import { setMarker } from '../../../../store/actions/marker';
import MapWrapper from '../MapWrapper';

import { setAvailabilityModal, setGeoCity } from '../../../../store/actions/app';
import { Tab, Menu } from "semantic-ui-react";



const NotifyModal = props => {
	const { open, closeNotifyModal } = props;
	return (
		<Modal
			open={open}
			onClose={closeNotifyModal}
			basic
			className="mt-0"
			closeOnDimmerClick={false}
		>
			<Modal.Content scrolling className="ui centered grid mx-0 px-0" style={{ display: "flex", alignItems: "center", height: "100vh" }}>
				<Segment inverted className="not-yet-avail">
					<p className="text-white itc-mdbold avail__title">Not yet available</p>
					<p className="avail__desc">
						We're sorry, but Fibrestream is not yet available at the location. Would you like to get notified when service is unavailable?
                    </p>
					<div>
						<Button secondary className="medium mr-2" onClick={closeNotifyModal}>No, thanks</Button>
						<Button secondary className="text-prime medium ml-2 mr-0" onClick={closeNotifyModal}>Yes, please</Button>
					</div>
				</Segment>
			</Modal.Content>
		</Modal>
	);
};

class MapModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			notifyModal: false,
			error: "",
			activeTabIndex: 1,
			activeCity: ''
		};

		this.activeTabIndex = {
			'Ottawa': 0,
			'British Columbia': 2,
			'Toronto': 1
		}
		this.resetError = this.resetError.bind(this);
		this.autocomplete = null;
		this.closeNotifyModal = this.closeNotifyModal.bind(this);
		this.openNotifyModal = this.openNotifyModal.bind(this);
		this.redirect = this.redirect.bind(this);
		this.openModal = this.openModal.bind(this);
		this.setActiveTabIndex = this.setActiveTabIndex.bind(this);
	}

	componentDidMount() {
		if (!this.props.isPageRequestFibreStream) {
			this.props.resetConnection();
		}
		this.setActiveTabIndex(this.props.geoCity);
		axios
			.get(`${Config.frontApiUrl}/availability/places`)
			.then(response => {
				this.formatMarkers(response.data.buildings || []);
			});
	}

	openNotifyModal(e) {

		e.preventDefault();
		this.setState({
			notifyModal: true
		});
	}

	closeNotifyModal() {

		this.setState({
			notifyModal: false
		});
	}

	setActiveTabIndex(city = '') {

		let currentCity = this.activeTabIndex[city] !== undefined ? city : 'Toronto';

		this.setState({
			activeTabIndex: this.activeTabIndex[currentCity],
			activeCity: currentCity
		});

	}

	resetError() {
		if (this.state.error) {
			this.setState({ error: null });
		}
	}

	redirect() {
		const { history } = this.props;
		history.push("/check-availability");
	}

	componentDidUpdate(prevProps) {
		
		if (this.props.geoCity && prevProps.geoCity !== this.props.geoCity) {
			this.setActiveTabIndex(this.props.geoCity);
		}

	}

	formatMarkers(markers) {

		const formatMarkers = markers.map((marker, index) => {
			return {
				location: marker.address,
				lat: marker.latitude,
				lon: marker.longitude,
				key: index,
				icon: this.getImage(marker.result_type),
				result_type: marker.result_type,
				city: marker.city,
				connection: marker,
				bf_on_net: marker.bf_on_net
			};
		})
		this.props.setMarker(formatMarkers);
	}

	getImage(type) {
		if (type === 1) {
			return redImage;
		}
		else if (type === 2) {
			return lightImage;
		}
		return blackImage;
	}

	openModal() {

		this.props.resetConnection();
		setTimeout(() => {
			this.props.setAvailabilityModal(true);
		})
	}


	render() {
		const { open, closeMapModal, modalRef } = this.props;
		const { notifyModal, activeTabIndex, activeCity } = this.state;
		//const addressPlaceholderText = (mobileMatchMedia()) ? 'Start typing your address...' : 'Start typing your building address';
		const panes = [
			{
				menuItem: (
					<Menu.Item key="1" onClick={() => { this.setActiveTabIndex('Ottawa') }} className="text-uc">
						Ottawa
                    </Menu.Item>
				),
				render: () => (
					<Tab.Pane key="1" attached={false} inverted={false}>
					</Tab.Pane>
				)
			},
			{
				menuItem: (
					<Menu.Item key="2" onClick={() => { this.setActiveTabIndex('Toronto') }} className="text-uc">
						Toronto
                    </Menu.Item>
				),
				render: () => (
					<Tab.Pane key="2" attached={false} inverted={false}>
					</Tab.Pane>
				)
			},
			{
				menuItem: (
					<Menu.Item key="3" onClick={() => { this.setActiveTabIndex('British Columbia') }} className="text-uc">
						Vancouver
					</Menu.Item>
				),
				render: () => (
					<Tab.Pane key="3" attached={false} inverted={false}>
					</Tab.Pane>
				)
			}
		];

		return (
			<Modal
				open={open}
				onClose={closeMapModal}
				style={{ boxShadow: "none", height: "100vh" }}
				className="vertical fullscreen js-map modal__map modal__location centered grid scrolling"
				mountNode={modalRef}
			>
				<Modal.Content className="scrolling ui centered grid px-0">
					<div className="ui display-1 text-black tablet only computer only centered grid mx-0 mb-6">
						Our locations
                    </div>
					{/* <Header className='title__main mobile only itc-mdbold' as='h1' textAlign='center'>Find a FibreReady Building
                    </Header> */}
					<div className="ui display-1 text-black centered grid modal__title desc my-0 text-black mobile only">
						Find a FibreReady Building
                    </div>
					<div className="sixteen wide column form-xs w-600 sm-text-center py-0 tab--menu">
						<Tab
							panes={panes}
							menu={{ text: true, className: "centered grid my-0" }}
							activeIndex={activeTabIndex}
						/>

					</div>
					<div className="map-responsive">
						<div className="ui container my-0">
							<MapWrapper
								googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${Config.apiKey}&v=3.exp&libraries=geometry,drawing,places`}
								loadingElement={<div style={{ height: `100%` }} />}
								containerElement={<div className="map" />}
								mapElement={<div style={{ height: `100%` }} />}
								activeCity={activeCity}
								{...this.props}
							/>
							<div className="info-window" />
						</div>
					</div>
				</Modal.Content>
				<Modal.Actions className="ui grid centered border-0">
					<button className="ui button deny close" onClick={closeMapModal}>
						<span className="times text-prime"><Image src={menuBtnClose} verticalAlign='middle' /></span> <span className="text-white close__text">Close</span>
					</button>
				</Modal.Actions>
				<NotifyModal open={notifyModal} closeNotifyModal={this.closeNotifyModal} />
			</Modal>
		);
	};
}

const mapStateToProps = state => {
	return {
		address: state.connection.address,
		markers: state.marker,
		geoCity: state.app.geoCity,
		isPageRequestFibreStream: state.app.isPageRequestFibreStream
	};
};

const mapDispatchToProps = dispatch => {
	return {
		resetConnection: () => dispatch(resetConnection()),
		setMarker: (markers) => dispatch(setMarker(markers)),
		setAvailabilityModal: (flag) => dispatch(setAvailabilityModal(flag)),
		setGeoCity: (city) => dispatch(setGeoCity(city))
	};
};

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(MapModal)
);



// WEBPACK FOOTER //
// ./src/components/home/map/modals/MapModal.js